const BOOK_COMPLETION_CUTS_NAMES = {
  1: 'completed',
  0.5: 'partially completed',
  0: 'started',
  null: 'no data'
};
export const BOOK_COMPLETION_CUTS = Object.keys(BOOK_COMPLETION_CUTS_NAMES).sort((a, b) => a === 'null' ? -1 : b === 'null' ? 1 : Number(a) - Number(b)).map((k, i, a) => ({
  value: k === 'null' ? null : Number(k),
  range: k === 'null' ? null : [Number(k), a[i + 1] || Infinity],
  name: BOOK_COMPLETION_CUTS_NAMES[k].replace(/(^\w)|(\s\w)/g, m => m.toUpperCase())
}));
export const PROFICIENCY_CUTS_COLORS = {
  0.8: '#32A852',
  0.6: '#F3CC1D',
  0: '#D6392B',
  null: '#DCDEDC'
};
class ProficiencyCut {
  constructor(name, min, max, color) {
    this.name = name;
    this.min = min;
    this.max = max;
    this.color = color;
  }
  get range() {
    const r = [this.min, this.max];
    return r.includes(null) ? null : r;
  }
  includes(value) {
    if (this.min === null && this.max === null) {
      return [null, undefined].includes(value);
    }
    return ![null, undefined].includes(value) && this.min <= value && value < this.max;
  }
}
export const PROFICIENCY_CUTS = [new ProficiencyCut('Proficient', 0.8, Infinity, '#32A852'), new ProficiencyCut('Developing', 0.6, 0.8, '#F3CC1D'), new ProficiencyCut('Needs Help', 0, 0.6, '#D6392B'), new ProficiencyCut('No Data', null, null, '#DCDEDC')];
export const SKILL_LVLS = ['domain', 'subDomain', 'skill', 'subSkill'];
export const LANGUAGES = [{
  name: 'Any language',
  value: null,
  abbreviation: "ANY",
  iso: null
}, {
  name: 'English only',
  value: 'ENGLISH',
  abbreviation: "ENG",
  iso: 'en'
}, {
  name: 'Spanish only',
  value: 'SPANISH',
  abbreviation: "ESP",
  iso: 'es'
}];
export const HISTORY_GROUPINGS = [{
  type: 'YEAR',
  label: 'Year',
  description: 'Annually'
}, {
  type: 'MONTH',
  label: 'Month',
  description: 'Monthly'
}, {
  type: 'WEEK',
  label: 'Week',
  description: 'Weekly'
}, {
  type: 'DAY',
  label: 'Day',
  description: 'Daily'
}];
export const SCHOOL_TYPE_COLORS = [{
  type: 'DISTRICT',
  tooltip: 'District School',
  color: '#99D4FA'
}, {
  type: 'COMMUNITY',
  tooltip: 'Community School',
  color: '#FBDDC0'
}, {
  type: 'PARTNER',
  tooltip: 'Partner School',
  color: '#D4C0FB'
}];